// extracted by mini-css-extract-plugin
export default {"downloadIcon":"detailReport_downloadIcon__VoU+k"};